import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import { MutationNames } from "./store/mutations";
import { Environment } from "./common/types";
import Loader from "./loader";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

Vue.config.productionTip = false;

Loader.InitialiseEnvironment()
  .then(env => {
    store.commit(MutationNames.Initialise, env);
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(err => {
    Loader.SetAppLoadingMessage(
      "Error: Unhandled exception when attempting to load the environment.",
      true
    );
    // tslint:disable-next-line:no-console
    console.error(err);
  });
